"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthUser = /** @class */ (function () {
    function AuthUser(userName, userInfo, userSession) {
        this.userName = userName;
        this.userInfo = userInfo;
        this.userSession = userSession;
    }
    return AuthUser;
}());
exports.default = AuthUser;
//# sourceMappingURL=auth.user.js.map